import styled from "styled-components";

export const Container = styled.div`
  padding: ${(props) => props.theme.padding.mobile} 20px;

  h1 {
    color: #2d2d2d;
    text-align: center;
    font-family: Mulish;
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: 30px;
    letter-spacing: 0.6px;
    margin-bottom: 32px;
  }

  @media (min-width: 640px) {
    padding: ${(props) => props.theme.padding.primary} 20px;
  }
`;

export const WrapperDataIugu = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px 16px;

  @media (min-width: 640px) {
    grid-template-columns: 1fr 1fr;

    grid-template-areas: "nome nome" "cnpj conta";

    > :nth-child(1) {
      grid-area: nome;
    }
    > :nth-child(2) {
      grid-area: cnpj;
    }
    > :nth-child(3) {
      grid-area: conta;
    }
  }
`;

export const Form = styled.form`
  display: grid;
  gap: 32px 16px;
  grid-template-columns: 1fr 1fr;
  margin: 0 auto;
  width: 100%;
  max-width: 700px;

  grid-template-areas:
    "title1 title1" "uf cidade" "title2 title2" "iugo iugo" "title3 title3" "tmedio tmedio" "margemAg margemAg"
    "qtdDomicilio qtdDomicilio" "qtdConcessionaria qtdConcessionaria" "title4 title4" "hinicio1 hinicio1" "hfinal1 hfinal1" "title5 title5" "hinicio2 hinicio2" "hfinal2 hfinal2" "title6 title6" "hinicio3 hinicio3" "hfinal3 hfinal3" "title7 title7" "bloqueio bloqueio" "limitrofes limitrofes" "buttom buttom";

  > :nth-child(1) {
    grid-area: title1;
  }

  > :nth-child(2) {
    grid-area: uf;
  }

  > :nth-child(3) {
    grid-area: cidade;
  }

  > :nth-child(4) {
    grid-area: title2;
  }

  > :nth-child(5) {
    grid-area: iugo;
  }

  > :nth-child(6) {
    grid-area: title3;
  }

  > :nth-child(7) {
    grid-area: tmedio;
  }

  > :nth-child(8) {
    grid-area: margemAg;
  }

  > :nth-child(9) {
    grid-area: qtdDomicilio;
  }

  > :nth-child(10) {
    grid-area: qtdConcessionaria;
  }

  > :nth-child(11) {
    grid-area: title4;
  }

  > :nth-child(12) {
    grid-area: hinicio1;
  }

  > :nth-child(13) {
    grid-area: hfinal1;
  }

  > :nth-child(14) {
    grid-area: title5;
  }

  > :nth-child(15) {
    grid-area: hinicio2;
  }

  > :nth-child(16) {
    grid-area: hfinal2;
  }

  > :nth-child(17) {
    grid-area: title6;
  }

  > :nth-child(18) {
    grid-area: hinicio3;
  }

  > :nth-child(19) {
    grid-area: hfinal3;
  }

  > :nth-child(20) {
    grid-area: title7;
  }

  > :nth-child(21) {
    grid-area: bloqueio;
  }

  > :nth-child(22) {
    grid-area: limitrofes;
  }

  > :nth-child(23) {
    grid-area: buttom;
    margin: 0 auto;
  }

  h3 {
    color: #2d2d2d;
    text-align: center;
    font-family: Mulish;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  }

  h4 {
    color: #2d2d2d;
    text-align: center;
    font-family: Mulish;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: fit-content;
    padding: 4px 8px;
    margin: 0 auto;
    border-radius: 2px;
    background: #f7f7f7;
  }

  @media (min-width: 640px) {
    grid-template-columns: repeat(6, 1fr);

    grid-template-areas:
      ". . title1 title1 . ."
      "uf uf uf cidade cidade cidade"
      ". . title2 title2 . ."
      "iugo iugo iugo iugo iugo iugo"
      ". . title3 title3 . ."
      "tmedio tmedio tmedio margemAg margemAg margemAg"
      "qtdDomicilio qtdDomicilio qtdDomicilio qtdConcessionaria qtdConcessionaria qtdConcessionaria"
      ". . title4 title4 . ."
      "hinicio1 hinicio1 hinicio1 hfinal1 hfinal1 hfinal1"
      ". . title5 title5 . ."
      "hinicio2 hinicio2 hinicio2 hfinal2 hfinal2 hfinal2"
      ". . title6 title6 . ."
      "hinicio3 hinicio3 hinicio3 hfinal3 hfinal3 hfinal3"
      ". . title7 title7 . ."
      "bloqueio bloqueio bloqueio bloqueio bloqueio bloqueio"
      "limitrofes limitrofes limitrofes limitrofes limitrofes limitrofes"
      ". . buttom buttom . .";
  }
`;
